"use strict";

exports.__esModule = true;
exports.PlantStateTag = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _polished = require("polished");
var _getPlantStateColor = require("../getPlantStateColor");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// The modern states are deep enough that dark text would not read on a solid
// chip; the chip takes a tint of the state instead, like the operator panel.
var chipBackground = function chipBackground(theme, stateId) {
  var color = (0, _getPlantStateColor.getPlantStateColor)(theme, stateId);
  if (!theme || !theme.uiModern || color === "transparent") {
    return color;
  }
  try {
    return (0, _polished.mix)(0.35, color, "#ffffff");
  } catch (e) {
    return color;
  }
};
var StateTag = _styledComponents["default"].span.withConfig({
  displayName: "PlantStateTag__StateTag",
  componentId: "sc-p6kv3j-0"
})(["& .bp6-tag :not([class*=\"bp6-intent-\"]){background:", ";border-radius:4px;padding:2px 5px;}& .bp6-tag{background:transparent !important;border-radius:4px;padding:2px 5px;}"], function (_ref) {
  var stateId = _ref.stateId,
    theme = _ref.theme;
  return chipBackground(theme, stateId);
});

/**
 * A simple Tag with the color fetched based on the state id
 */
var PlantStateTag = exports.PlantStateTag = function PlantStateTag(props) {
  return /*#__PURE__*/_react["default"].createElement(StateTag, {
    key: props.stateId,
    stateId: props.stateId
  }, /*#__PURE__*/_react["default"].createElement(_core.Tag, {
    key: props.stateId
  }, props.label));
};